/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface AffiliateTeamAllOfFarming
 */
export interface AffiliateTeamAllOfFarming {
  /**
   *
   * @type {number}
   * @memberof AffiliateTeamAllOfFarming
   */
  totalEarned?: number
  /**
   *
   * @type {boolean}
   * @memberof AffiliateTeamAllOfFarming
   */
  isWeakTeam?: boolean
  /**
   *
   * @type {number}
   * @memberof AffiliateTeamAllOfFarming
   */
  members?: number
  /**
   *
   * @type {number}
   * @memberof AffiliateTeamAllOfFarming
   */
  usdInNmxPools?: number
  /**
   *
   * @type {number}
   * @memberof AffiliateTeamAllOfFarming
   */
  usdInAllPools?: number
}

export function AffiliateTeamAllOfFarmingFromJSON(json: any): AffiliateTeamAllOfFarming {
  return AffiliateTeamAllOfFarmingFromJSONTyped(json, false)
}

export function AffiliateTeamAllOfFarmingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AffiliateTeamAllOfFarming {
  if (json === undefined || json === null) {
    return json
  }
  return {
    totalEarned: !exists(json, 'totalEarned') ? undefined : json['totalEarned'],
    isWeakTeam: !exists(json, 'isWeakTeam') ? undefined : json['isWeakTeam'],
    members: !exists(json, 'members') ? undefined : json['members'],
    usdInNmxPools: !exists(json, 'usdInNmxPools') ? undefined : json['usdInNmxPools'],
    usdInAllPools: !exists(json, 'usdInAllPools') ? undefined : json['usdInAllPools'],
  }
}

export function AffiliateTeamAllOfFarmingToJSON(value?: AffiliateTeamAllOfFarming | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    totalEarned: value.totalEarned,
    isWeakTeam: value.isWeakTeam,
    members: value.members,
    usdInNmxPools: value.usdInNmxPools,
    usdInAllPools: value.usdInAllPools,
  }
}
